export default function RowNumber(params) {
  const {
    rowIndex
  } = params;
  const rowNumberCell = document.createElement('div');
  rowNumberCell.classList.add('w5-row-number-cell');
  const rowNumber = rowIndex + 1;
  rowNumberCell.innerHTML = rowNumber;
  return rowNumberCell;
}